// extracted by mini-css-extract-plugin
module.exports = {"form":"scheduleOfExpenses_form__yamb6","total":"scheduleOfExpenses_total__2g-Lt","fixed":"scheduleOfExpenses_fixed__33net"};